export default {
    secret : 'cXZia3ByMzY1LXowJDUqMSMk',
    expiresIn: 10800
  }
  